module.exports = __webpack_public_path__ + "img/header_hoteleria.335b8804.png";